import React from "react";
import { Calendar, Briefcase, BookOpen, GraduationCap, Sparkles, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import SectionTitle from "@/components/SectionTitle";

const NOTICES = [
  {
    type: "Course Launch",
    icon: BookOpen,
    title: "Korean Language Training Program — Registrations Open",
    body: "Registrations are officially open for our structured Korean Language Training Program covering Level 1, Level 2, and Level 1+2 Combo. Classes run 3 days per week (2 hours per session). Exact timings and days will be announced soon. Fill out the official registration form directly on our Courses page.",
    link: "/courses",
    linkText: "View Course & Fill Registration Form →",
  },
  {
    type: "Youth Diplomacy",
    icon: Sparkles,
    title: "Claritas MUN Hub — Rules of Procedure Bootcamp",
    body: "Claritas MUN Division is launching delegate training bootcamps, committee allocations (UNSC, UNGA, Crisis), and 1-on-1 RoP mentorship sessions.",
    link: "/claritas",
    linkText: "Visit Claritas MUN Hub →",
  },
];

export default function Notice() {
  return (
    <>
      <section className="relative bg-ribbon overflow-hidden" data-testid="notice-hero">
        <div className="absolute inset-0 grain opacity-30" />
        <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-16 relative">
          <div className="max-w-3xl fade-up">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand text-[11px] uppercase tracking-[0.2em] font-semibold">
              <Calendar size={12} /> Notice Board
            </div>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mt-5 leading-[1.02] text-brand-ink">
              Updates, deadlines & opportunities — all in one place.
            </h1>
            <p className="mt-5 text-brand-muted text-lg leading-relaxed">
              Stay current on scholarship cycles, course launches, internship openings, webinars and activity drops from Veritas Sphere.
            </p>
          </div>
        </div>
      </section>

      <section className="section bg-brand-cream" data-testid="notice-list">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <SectionTitle eyebrow="Latest Announcements" title="Active Notices & Updates" subtitle="Check out our latest course announcements, scholarship intakes, and student opportunities." />
          <ol className="mt-12 relative space-y-6">
            {NOTICES.map((n, i) => (
              <li key={i} className="fade-up" style={{ animationDelay: `${i * 60}ms` }} data-testid={`notice-${i}`}>
                <div className="card-soft p-7">
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 rounded-xl bg-brand/10 text-brand grid place-items-center shrink-0">
                      <n.icon size={22} strokeWidth={1.6} />
                    </div>
                    <div className="flex-1">
                      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand/10 text-brand text-[11px] uppercase tracking-[0.18em] font-semibold">
                        <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse" /> Latest Notice · {n.type}
                      </div>
                      <div className="font-display text-xl font-bold text-brand-ink mt-3">{n.title}</div>
                      <p className="text-brand-muted text-[15px] leading-relaxed mt-2">{n.body}</p>
                      {n.link && (
                        <div className="mt-4">
                          <Link to={n.link} className="text-xs font-semibold text-brand hover:underline inline-flex items-center gap-1">
                            {n.linkText}
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </>
  );
}
